'use client'; // Error boundaries must be Client Components

import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { ErrorPageContent } from '@/app/components/ErrorPageContent';
import ErrorPageNavigation from '@/app/components/Navigation/ErrorPageNavigation';
import PageLayout from '@/app/components/PageLayout';
import BulkOrderBackground from '@/app/components/ui/BulkOrderBackground';
import { Button } from '@/app/components/ui/Button';

export default function ErrorPage({
  error,
  reset,
}: {
  readonly error: Error & { digest?: string };
  readonly reset: () => void;
}) {
  const t = useTranslations();
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div>
      <ErrorPageNavigation />
      <PageLayout
        name="500"
        className="relative flex min-h-[calc(100dvh_-_60px)] w-full items-center justify-center desktop:min-h-[calc(100dvh_-_80px)]"
      >
        <ErrorPageContent
          description={t('error_page_description')}
          title={t('error_page_title')}
          headline={t('error_page_headline')}
        >
          <Button className="max-w-fit" onClick={reset}>
            {t('server_error_button')}
          </Button>
        </ErrorPageContent>
        <BulkOrderBackground />
      </PageLayout>
    </div>
  );
}
